__turbopack_context__.v({
  "backdrop": "mfrm-modal-module-scss-module__SdaKYq__backdrop",
  "bounceIn": "mfrm-modal-module-scss-module__SdaKYq__bounceIn",
  "bounceOut": "mfrm-modal-module-scss-module__SdaKYq__bounceOut",
  "content": "mfrm-modal-module-scss-module__SdaKYq__content",
  "dialog": "mfrm-modal-module-scss-module__SdaKYq__dialog",
  "modal": "mfrm-modal-module-scss-module__SdaKYq__modal",
});
